import { ConsentContext } from '@context/ConsentContext'
import { SurveyContext } from '@context/SurveyContext'
import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { isAdminPreviewSession } from '../dev/applyAdminPreviewQuery'

export const useEnsureSurveyIsAvailableAndConsent = () => {
  const { hasConsented } = useContext(ConsentContext)
  const { enabled } = useContext(SurveyContext)
  const navigate = useNavigate()

  useEffect(() => {
    // Admin playground: AutoConsent owns routing; do not bounce to home/consent mid-bootstrap.
    if (isAdminPreviewSession()) return

    if (!enabled) {
      navigate('/')
    }
    if (!hasConsented) {
      navigate('/consent')
    }
  }, [enabled, hasConsented, navigate])
}
